// @flow
import styles from './ViewAllLink.less';

import React, { PureComponent } from 'react';

import { TextLink, ScreenReaderOnly } from 'seek-style-guide/react';
import NavLink from 'src/components/NavLink/NavLink';

type Props = {
  analytics: string,
  dataAutomation?: string,
  location: string,
  screenReaderText: string
};

export default class ViewAllLink extends PureComponent<Props> {
  props: Props;

  render() {
    const {
      analytics,
      dataAutomation,
      location,
      screenReaderText
    } = this.props;

    return (
      <NavLink
        analytics={analytics}
        chevron="right"
        children={
          <span>
            View all<ScreenReaderOnly>{screenReaderText}</ScreenReaderOnly>
          </span>
        }
        className={styles.viewAll}
        component={TextLink}
        data-automation={dataAutomation}
        location={location}
      />
    );
  }
}
